// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"88c05e37","114":"96509e78","177":"6c8640c9","286":"aa68f200","303":"ce0fe164","348":"2bff6ac3","361":"1e6ad9c3","567":"e00e2f95","914":"bb11bb5b","989":"b03a65b6"}[chunkId] + ".chunk.js";
};